<template>
  <div>
    <div class="calculator-input-values">
      <h5>Данные для расчета</h5>

      <p class="calculator-comment">
        Укажите площадь гидроизолируемой конструкции
      </p>
      <table>
        <tbody>
          <tr>
            <td>Площадь, кв.м</td>
            <td>
              <input
                v-model="area"
                id="calc-polymfloor-area"
                type="number"
                placeholder="0"
                min="1"
                max="1500"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="calculator-output-values">
      <h5>Результаты расчета</h5>
      <table>
        <thead>
          <tr>
            <th colspan="2">Результаты расчета</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Расчётное количество готового раствора, кг</td>
            <td class="calc-result-value-container" width="100">
              {{ readyWeight }}
            </td>
          </tr>
          <tr v-if="!kit">
            <td>Расчётное количество сухой смеси, кг</td>
            <td class="calc-result-value-container">{{ dryWeight }}</td>
          </tr>
          <tr v-if="kit">
            <td>Количество комплектов, шт</td>
            <td>{{ kitCount }}</td>
          </tr>
          <tr v-else>
            <td>Количество мешков, шт</td>
            <td>{{ packCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      area: 1,
    };
  },
  props: {
    multiplier1: {
      type: Number,
      default: 0,
    },
    multiplier2: {
      type: Number,
      default: 0,
    },
    kit: Boolean,
  },
  computed: {
    readyWeight() {
      return (this.area * this.multiplier1).toFixed(1);
    },
    dryWeight() {
      return (this.area * this.multiplier2).toFixed(1);
    },
    kitCount() {
      return Math.ceil(this.readyWeight / 25);
    },
    packCount() {
      return Math.ceil(this.dryWeight / 20);
    },
  },
};
</script>

<style lang="scss" scoped></style>
